export interface ImageDataModel {
    id: number;
    name: string;
    description: string;
    category: number;
    filename: string;
    file: string;
}

export interface ImageResponse {
    count: number;
    total_pages: number;
    current_page: number;
    next: string | null;
    previous: string | null;
    results: ImageDataModel[];
}

export enum ImageCategory {
    UNKNOWN = 0,
    TRANSACTION = 1,
    APP_INSTRUCTION = 2,
    INFORMATION = 3
}